import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "./TermsModal.css";

interface TermsModalProps {
  show: boolean;
  onHide: () => void;
  onAccept: () => void;
  imageUrl: string;
}

const TermsModal: React.FC<TermsModalProps> = ({
  show,
  onHide,
  onAccept,
  imageUrl,
}) => {
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const handleAccept = () => {
    if (acceptedTerms) {
      onAccept();
      onHide();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      className="terms-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title className="terms-title">
          Termos e Condições para Download e Uso de Imagens do Banco de Dados
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="terms-body">
        <p className="terms-intro">
          Ao fazer download e utilizar as imagens disponibilizadas em nosso
          banco de dados, o usuário concorda com os seguintes termos e
          condições:
        </p>

        <section className="terms-section">
          <h2>1. Direitos Autorais e Créditos</h2>
          <p>
            1.1 Todas as imagens presentes no banco de dados são protegidas por
            direitos autorais. O uso de qualquer imagem requer a atribuição dos
            devidos créditos ao autor e à instituição fornecedora.
          </p>
          <p>
            1.2 O crédito deve incluir, de forma visível, o nome do
            autor/coletor da imagem e a instituição vinculada. A frase
            recomendada para atribuição é: "Imagem por [Nome do Autor] –
            [Instituição]"
          </p>
          <p>
            1.3 É proibido remover marcas d'água, logotipos, ou qualquer
            identificação presente na imagem que indique autoria e propriedade.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. Uso Permitido</h2>
          <p>
            2.1 As imagens podem ser usadas exclusivamente para fins acadêmicos,
            educacionais ou científicos, desde que os devidos créditos sejam
            atribuídos.
          </p>
          <p>
            2.2 O uso comercial das imagens (incluindo, mas não se limitando a,
            venda, propaganda e qualquer finalidade com lucro) é estritamente
            proibido sem a autorização por escrito dos detentores dos direitos.
          </p>
          <p>
            2.3 Modificações nas imagens são permitidas apenas para ajustes de
            tamanho ou resolução, mantendo-se a integridade da imagem e os
            créditos originais.
          </p>
        </section>

        <section className="terms-section">
          <h2>3. Proibições e Responsabilidades</h2>
          <p>
            3.1 É proibida a distribuição ou disponibilização pública das
            imagens baixadas sem autorização.
          </p>
          <p>
            3.2 O usuário é responsável por garantir que qualquer uso das
            imagens seja feito em conformidade com as leis aplicáveis de
            direitos autorais e propriedade intelectual.
          </p>
          <p>
            3.3 O descumprimento desses termos poderá resultar em penalidades
            legais, incluindo, mas não se limitando a, multas e ações judiciais,
            conforme previsto nas leis aplicáveis.
          </p>
        </section>

        <section className="terms-section">
          <h2>4. Leis Aplicáveis</h2>
          <p>
            Este termo está em conformidade com as seguintes regulamentações de
            direitos autorais e propriedade intelectual:
          </p>
          <ul>
            <li>
              Lei de Direitos Autorais Brasileira (Lei nº 9.610/1998): Protege a
              propriedade intelectual de obras e garante o direito de atribuição
              ao autor.
            </li>
            <li>
              Convenção de Berna para a Proteção das Obras Literárias e
              Artísticas: Convenção internacional que protege os direitos de
              autores sobre suas criações.
            </li>
            <li>
              Diretiva Europeia de Direitos de Autor (Diretiva UE) 2019/790):
              Regula o uso de conteúdos protegidos por direitos autorais na
              União Europeia.
            </li>
            <li>
              Digital Millennium Copyright Act (DMCA): Lei de direitos autorais
              dos Estados Unidos que protege obras digitais e regulamenta o uso
              na internet.
            </li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>5. Aceitação dos Termos</h2>
          <p>
            Ao fazer download de qualquer imagem, o usuário declara estar ciente
            e de acordo com os termos e condições aqui estabelecidos. Qualquer
            uso não autorizado será considerado uma violação dos termos e
            sujeitará o usuário às consequências legais cabíveis.
          </p>
        </section>

        <div className="terms-checkbox">
          <label>
            <input
              type="checkbox"
              checked={acceptedTerms}
              onChange={(e) => setAcceptedTerms(e.target.checked)}
            />
            <span>
              Confirmo que li e aceito os termos e condições e a política de
              privacidade.
            </span>
          </label>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} className="btn-cancel">
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handleAccept}
          disabled={!acceptedTerms}
        >
          Aceitar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsModal;
